var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 71C55.7777 71 71 55.7777 71 37C71 18.2223 55.7777 3 37 3C18.2223 3 3 18.2223 3 37C3 55.7777 18.2223 71 37 71Z",
    fill: "#EEF9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 51.1667V37M37 27.3352H37.0382M71 37C71 55.7777 55.7777 71 37 71C18.2223 71 3 55.7777 3 37C3 18.2223 18.2223 3 37 3C55.7777 3 71 18.2223 71 37Z",
    stroke: "#4DBBFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlue);
export default __webpack_public_path__ + "static/media/warning_blue.ea926c94d9400979cfe822bd6ead57f0.svg";
export { ForwardRef as ReactComponent };